import { getUserInfo } from "Admin/Service/Auth";
import { Layout } from "antd";
import { saveUser } from "Redux/Slices/User";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import Content from "./Content/Content";
import Sidebar from "./Sidebar/Sidebar";
const LayoutAdmin = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    getUserInfo((res) => {
      dispatch(saveUser(res.data));
    });
  }, []);
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <Content />
      </Layout>
    </Layout>
  );
};
export default LayoutAdmin;
